import React, { useState } from 'react';
import { Card } from '../../components/ui/Card';
import { Table } from '../../components/ui/Table';
import { Input } from '../../components/ui/Input';
import { Select } from '../../components/ui/Select';
import { Button } from '../../components/ui/Button';
import { Modal } from '../../components/ui/Modal';
import { Search, Filter, Download, Lock } from 'lucide-react';
import { auditLogs } from '../../data/mockData';
export function AuditTrail() {
  const [selectedLog, setSelectedLog] = useState<any>(null);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const handleRowClick = (item: any) => {
    setSelectedLog(item);
    setShowDetailModal(true);
  };
  return <div className="space-y-6" data-id="element-697">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-698">
        <div data-id="element-699">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-700">
            Audit Trail & Log Sistem
          </h1>
          <p className="text-gray-500 mt-1" data-id="element-701">
            Rekam jejak aktivitas user untuk kepatuhan audit
          </p>
        </div>
        <Button icon={<Download size={18} data-id="element-703" />} data-id="element-702">Export Audit Package</Button>
      </div>

      <Card data-id="element-704">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6" data-id="element-705">
          <div className="sm:col-span-2" data-id="element-706">
            <Input placeholder="Cari User ID, Aktivitas, atau Objek..." leftIcon={<Search size={18} data-id="element-708" />} data-id="element-707" />
          </div>
          <Input type="date" label="Tanggal" data-id="element-709" />
          <div className="flex items-end" data-id="element-710">
            <Button variant="secondary" className="w-full" icon={<Filter size={16} data-id="element-712" />} data-id="element-711">
              Filter
            </Button>
          </div>
        </div>
        <Table columns={[{
        header: 'Waktu',
        accessor: (item: any) => <div className="min-w-0" data-id="element-714">
                  <div className="text-sm font-semibold text-gray-900" data-id="element-715">
                    {item.time}
                  </div>
                  <div className="flex items-center gap-1 mt-0.5" data-id="element-716">
                    <Lock size={10} className="text-gray-400" data-id="element-717" />
                    <span className="text-xs text-gray-400" data-id="element-718">Immutable</span>
                  </div>
                </div>
      }, {
        header: 'User',
        accessor: (item: any) => <div className="min-w-0" data-id="element-719">
                  <div className="font-semibold text-gray-900 truncate" data-id="element-720">
                    {item.user}
                  </div>
                  <div className="text-xs text-gray-500 mt-0.5" data-id="element-721">{item.ip}</div>
                </div>
      }, {
        header: 'Aktivitas',
        accessor: (item: any) => <div className="min-w-0" data-id="element-722">
                  <div className="font-medium text-gray-900" data-id="element-723">{item.action}</div>
                  <div className="text-xs text-gray-500 mt-0.5" data-id="element-724">
                    {item.module}
                  </div>
                </div>,
        className: 'hidden md:table-cell'
      }, {
        header: 'Detail Perubahan',
        accessor: (item: any) => <span className="text-sm text-gray-600 truncate block" data-id="element-725">
                  {item.detail}
                </span>,
        className: 'hidden lg:table-cell'
      }, {
        header: 'Aksi',
        accessor: () => <Button size="sm" variant="ghost" data-id="element-726">
                  Detail
                </Button>
      }]} data={auditLogs} keyExtractor={i => i.time + i.user} onRowClick={handleRowClick} data-id="element-713" />
      </Card>

      <Modal isOpen={showDetailModal} onClose={() => setShowDetailModal(false)} title="Detail Audit Log" size="lg" data-id="element-727">
        {selectedLog && <div className="space-y-4" data-id="element-728">
            <div className="grid grid-cols-2 gap-4" data-id="element-729">
              <div data-id="element-730">
                <p className="text-sm text-gray-500 mb-1" data-id="element-731">Timestamp</p>
                <p className="font-semibold text-gray-900" data-id="element-732">
                  {selectedLog.time}
                </p>
              </div>
              <div data-id="element-733">
                <p className="text-sm text-gray-500 mb-1" data-id="element-734">User</p>
                <p className="font-semibold text-gray-900" data-id="element-735">
                  {selectedLog.user}
                </p>
              </div>
              <div data-id="element-736">
                <p className="text-sm text-gray-500 mb-1" data-id="element-737">IP Address</p>
                <p className="font-mono text-sm text-gray-900" data-id="element-738">
                  {selectedLog.ip}
                </p>
              </div>
              <div data-id="element-739">
                <p className="text-sm text-gray-500 mb-1" data-id="element-740">Module</p>
                <p className="font-semibold text-gray-900" data-id="element-741">
                  {selectedLog.module}
                </p>
              </div>
            </div>

            <div data-id="element-742">
              <p className="text-sm text-gray-500 mb-2" data-id="element-743">Action</p>
              <div className="p-3 bg-blue-50 rounded-lg border border-blue-200" data-id="element-744">
                <p className="font-semibold text-bulog-blue" data-id="element-745">
                  {selectedLog.action}
                </p>
              </div>
            </div>

            <div data-id="element-746">
              <p className="text-sm text-gray-500 mb-2" data-id="element-747">Detail Perubahan</p>
              <div className="p-4 bg-gray-50 rounded-lg border border-gray-200 font-mono text-xs" data-id="element-748">
                <pre className="whitespace-pre-wrap text-gray-700" data-id="element-749">
                  {selectedLog.detail}
                </pre>
              </div>
            </div>

            <div className="p-3 bg-yellow-50 border border-yellow-200 rounded-lg" data-id="element-750">
              <div className="flex items-center gap-2" data-id="element-751">
                <Lock size={16} className="text-yellow-700" data-id="element-752" />
                <p className="text-sm font-medium text-yellow-900" data-id="element-753">
                  Log ini bersifat immutable dan tidak dapat diubah
                </p>
              </div>
            </div>
          </div>}
      </Modal>
    </div>;
}